import { isNil, omitBy } from 'lodash'

import { isMobileDevice } from 'lib/device'
import { openConferenceCallRoom } from 'lib/conferenceCall'

import useGlobalConfirmBox from 'features/GlobalConfirmBox/hooks/useGlobalConfirmBox'

const useOpenConferenceCall = () => {
  const { showSuggestToUseOnAppConfirmBox } = useGlobalConfirmBox()

  const openConferenceCall = ({
    conferenceCallId,
    allowOnMobile = false,
    inviteId = undefined,
    targetId = undefined,
  }: {
    conferenceCallId: string
    allowOnMobile?: boolean
    inviteId?: string
    targetId?: string
  }) => {
    if (isMobileDevice && !allowOnMobile) {
      showSuggestToUseOnAppConfirmBox({
        confirmBoxProps: {
          onCancel: () =>
            openConferenceCallRoom(conferenceCallId, {
              inviteId: inviteId,
              targetId: targetId,
            }),
        },
      })
      return
    }

    openConferenceCallRoom(
      conferenceCallId,
      omitBy(
        {
          invite: inviteId,
          target: targetId,
        },
        isNil
      )
    )
  }

  return {
    openConferenceCall,
  }
}

export default useOpenConferenceCall
